'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const EditTitlesIcon = withDefaultValues((props: React.SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10 19V7h5V5H3v2h5v12h2zm7 0v-6h3v-2h-8v2h3v6h2z" fill="currentColor" /></svg>);